import React from 'react';
import classNames from 'classnames';

import { Button } from '@gn-audio/jss-components';

import { useHearingTest } from '../HearingTestContext';
import { translations } from '../translations/en';
import { STEP_NAMES } from '../types/HearingTestTypes';

interface NavigationButtonsProps {
  onNext?: () => void;
  disableNext?: boolean;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onNext,
  disableNext = false,
}) => {
  const { state, goToStep } = useHearingTest();

  const shouldShowPrevious = state.currentStep > STEP_NAMES.INTRODUCTION;

  const isHearingTestStep =
    state.currentStep > STEP_NAMES.LEFT_EAR_INTRO &&
    state.currentStep <= STEP_NAMES.RIGHT_4000HZ &&
    state.currentStep !== STEP_NAMES.RIGHT_EAR_INTRO;

  const handleNext = () => {
    if (onNext) {
      onNext();
    } else {
      goToStep(state.currentStep + 1);
    }
  };

  const handlePrevious = () => {
    goToStep(state.currentStep - 1);
  };

  const containerClasses = isHearingTestStep
    ? 'gap-4 mt-8 flex justify-between max-md:fixed max-md:bottom-0 max-md:left-0 max-md:z-[101] max-md:mt-0 max-md:w-full max-md:flex-col-reverse max-md:gap-2 max-md:bg-white/80 max-md:p-4 max-md:backdrop-blur-sm'
    : 'gap-4 mt-8 flex justify-between';

  return (
    <div className={containerClasses}>
      {shouldShowPrevious && (
        <Button onClick={handlePrevious} variant="secondary" size="m" className="max-md:w-full">
          {translations.prevpage}
        </Button>
      )}
      <Button
        onClick={handleNext}
        disabled={disableNext}
        variant="primary"
        size="m"
        className={classNames('disabled:cursor-not-allowed disabled:!opacity-50 max-md:w-full', {
          'm-auto': !shouldShowPrevious,
        })}
      >
        {isHearingTestStep ? translations.savenadcontinue : translations.nextpage}
      </Button>
    </div>
  );
};
